import { render, staticRenderFns } from "./Wh5eNewBuy.vue?vue&type=template&id=f37afc12&scoped=true"
import script from "./Wh5eNewBuy.vue?vue&type=script&lang=js"
export * from "./Wh5eNewBuy.vue?vue&type=script&lang=js"
import style0 from "./Wh5eNewBuy.vue?vue&type=style&index=0&id=f37afc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37afc12",
  null
  
)

export default component.exports